<template>
  <div>

    <!-- SHOP PICKER FOR GAA/SI, SUPPORT REMOTE METHOD -->
    <el-select ref="main-select" class="select-primary" placeholder="（以關鍵字或ID搜尋店家）" :style="`width: ${width}px`"
                v-model="selectedShop"
                clearable filterable size="large"
                :remote="userType !== 'eaa'" :reserve-keyword="userType !== 'eaa'"
                :remote-method="remoteSearchByKeyword" :loading="isLoading"
                @change="onShopSelected" @clear="clearSearch"
                @hook:mounted="cancelReadOnly"
                @visible-change="cancelReadOnly">
      <el-option class="select-primary" v-for="shop in shops"
                  :value="shop.id" :label="shop.name" :key="shop.id">
      </el-option>
    </el-select>

    <!-- SHOP PICKER FOR EAA -->
    <!-- <el-select class="select-primary" placeholder="（請選擇店家）" v-else
                v-model="selectedShop"
                clearable filterable size="large" :loading="isLoading"
                @change="onShopSelected">
      <el-option class="select-primary" v-for="shop in shops"
                  :value="shop.id" :label="shop.name" :key="shop.id">
      </el-option>
    </el-select> -->
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ShopPicker',
  props: {
    width: {
      type: Number,
      default: 160
    }
  },

  mounted() {
    if (this.userType == 'eaa')
      this.fetchListOfShops();
  },

  methods: {

    remoteSearchByKeyword(keyword) {
      if (keyword !== undefined && !keyword.length)
        return;
      this.keyword = keyword;

      if (this.remoteSearchTimeout)
        clearTimeout(this.remoteSearchTimeout);
      this.isLoading = true;
      this.remoteSearchTimeout = setTimeout(this.fetchListOfShops, 1000);
    },
    clearSearch() {
      if (this.userType !== 'eaa')
        this.shops = [ ]; 
    },
    cancelReadOnly(onOff) {
      //FIXME: Workaround for enabling soft-keyboard on iOS devices due to this: https://github.com/ElemeFE/element/issues/12742 
      this.$nextTick(() => {
        if (onOff) return;
        const select = this.$refs['main-select'];
        const input = select.$el.querySelector('.el-input__inner');
        input.removeAttribute('readonly');
      });
    },

    fetchListOfShops() {

      return axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/shops`
        + (this.keyword && this.keyword.length? `?keyword=${this.keyword}`: '')
      )
      .then(response => {
        // console.log(`[ShopPicker] fetchListOfShops`, response.data);

        if (this.userType !== 'eaa') {
          this.shops = response.data.map(shop => {
            shop['merchantId'] = shop['businessId'];
            return shop;
          });
        }
        else if (Array.isArray(response.data.shops)) {
          this.shops = [ ];
          response.data.shops.forEach(shop => {
            this.shops.push({ id: shop['accountId'], name: shop['name'], merchantId: shop['merchantId'] });
          });
        }
        else {
          throw new Error(`Cannot resolve response.data of shop list.`);
        }
      })
      .catch(err => {
        console.error(`[ShopPicker] Cannot fetch shop list`, err);
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    onShopSelected(shopId) {
      // this.$emit('select', shopId, this.selectedShopName);
      this.$emit('select', shopId, this.shops.find(shop => this.selectedShop == shop.id ));
    }
  },

  data() {
    return {
      isLoading: false,
      shops: [ ],
      selectedShop: null,

      remoteSearchTimeout: false,
      keyword: ''
    };
  },

  computed: {

    selectedShopName() {
      let ret = this.shops.find(shop => {
        return shop.id === this.shop;
      });
      if (ret) return ret.name;
      return null;
    },

    userType() {
      return this.$store.getters.userType;
    }
  }
}
</script>
